import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function ComodatarStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Persoana juridica"
          description="Comodatarul este o firma / societate comerciala"
          checked={!!data.comodatarPJ}
          onChange={() => update("comodatarPJ")(!data.comodatarPJ)}
        />
      </div>

      {data.comodatarPJ ? (
        <>
          <InputField label="Denumire societate" value={data.comodatarFirma} onChange={update("comodatarFirma")} placeholder="ex: SC Exemplu SRL" required error={errors.comodatarFirma} />
          <InputField label="CUI" value={data.comodatarCUI} onChange={update("comodatarCUI")} placeholder="ex: RO12345678" required half error={errors.comodatarCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.comodatarRegCom} onChange={update("comodatarRegCom")} placeholder="ex: J40/1234/2020" half error={errors.comodatarRegCom} />
          <InputField label="Sediu social" value={data.comodatarSediu} onChange={update("comodatarSediu")} placeholder="ex: Str. Alta nr. 5, Cluj-Napoca" required error={errors.comodatarSediu} />
          <InputField label="Reprezentant legal" value={data.comodatarReprezentant} onChange={update("comodatarReprezentant")} placeholder="ex: Ionescu Maria" required error={errors.comodatarReprezentant} />
        </>
      ) : (
        <>
          <InputField label="Nume complet" value={data.comodatarNume} onChange={update("comodatarNume")} placeholder="ex: Ionescu Maria" required error={errors.comodatarNume} />
          <InputField label="Adresa de domiciliu" value={data.comodatarAdresa} onChange={update("comodatarAdresa")} placeholder="ex: Str. Alta nr. 5, Cluj-Napoca" required error={errors.comodatarAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.comodatarCNP} onChange={update("comodatarCNP")} placeholder="ex: 2234567890123" half error={errors.comodatarCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.comodatarCI} onChange={update("comodatarCI")} placeholder="ex: MZ 654321" half error={errors.comodatarCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}
    </div>
  );
}
